module.exports = __webpack_public_path__ + "static/img/rank_background2.bfc92f5d.png";